import React from "react";
import { Button, Box, CircularProgress } from "@mui/material";

const ProceedButton = ({ text, onClick, disabled = false, isLoading = false }) => {
  return (
    <Box width="100%">
      <Button
        fullWidth
        onClick={onClick}
        disabled={disabled || isLoading}
        sx={{
          padding: "10px 20px",
          backgroundColor: "#3377FF",
          color: "#fff",
          border: "3px solid #004DE5",
          borderRadius: "16px",
          cursor: "pointer",
          fontWeight: 700,
          fontSize: "14px",
          textTransform: "none",
          fontFamily: "Inter",
          lineHeight: "normal",
          whiteSpace: "nowrap",
          boxShadow:
            "0px 4px 8px 0px #0000FF29, inset 0px -4px 0px 0px #1A66FF, inset 0px 1px 0px 0px #80AAFF",

          "&:hover": {
            backgroundColor: "#2B6BFF", // slightly darker on hover
            border: "3px solid #003FCC",
            boxShadow:
              "0px 4px 8px 0px #0000FF29, inset 0px -4px 0px 0px #155CFF, inset 0px 1px 0px 0px #6B9BFF",
          },

          "&.Mui-disabled": {
            cursor: "not-allowed",
            border: "3px solid #004DE5",
            backgroundColor: "#3377FF",
            color: "#fff",
            opacity: 0.7,
            boxShadow:
              "0px 4px 8px 0px #0000FF29, inset 0px -4px 0px 0px #1A66FF, inset 0px 1px 0px 0px #80AAFF",
          },
        }}
      >
        {isLoading ? (
          <CircularProgress size={20} sx={{ color: "#fff" }} />
        ) : (
          text
        )}
      </Button>
    </Box>
  );
};

export default ProceedButton;